module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBox":{"button":"Detail","customButton":"Začít konfigurovat","priceWithoutTax":"bez DPH"}}}')
  delete Component.options._Ctor
}
